import { useKompis } from '../contexts';
export const useIsMetricMeasures = () => {
    const { dexfAppSettings } = useKompis();
    return dexfAppSettings.localisation.useMetricMeasures;
};
//# sourceMappingURL=useIsMetricMeasures.js.map